import { render, staticRenderFns } from "./message-pattern-textarea.vue?vue&type=template&id=88d092e8&scoped=true&"
import script from "./message-pattern-textarea.vue?vue&type=script&lang=js&"
export * from "./message-pattern-textarea.vue?vue&type=script&lang=js&"
import style0 from "./message-pattern-textarea.vue?vue&type=style&index=0&id=88d092e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d092e8",
  null
  
)

export default component.exports